import styled from "styled-components";

export const InputLabel = styled.label`
font-family: Poppins;
font-size: 16px;
font-weight: 500;
line-height: 24px;
text-align: left;
color: #333333;
`;

export const InputType = styled.input`
border-radius:12px;
border: 1px solid #66666659;
/* height:55px; */
padding:10px;
`;

export const SelectBorder = styled.select`
border: 1px solid #66666659;
border-radius:12px;
padding:10px;
font-family: Poppins;
font-size: 13px;
font-weight: 400;
line-height: 24px;
text-align: left;
color: #333333;
`;


export const SelectBgWhiteBorder = styled.select`
    border: 1px solid #66666659;
    border-radius: 5px;
    padding: 8px 10px;
    font-family: Poppins;
    font-size: 13px;
    font-weight: 400;
    line-height: 24px;
    color: #333333;
    min-width: 100px;
`;

export const CheckboxInput = styled.input`
font-size: 12px;
font-weight: 400;
line-height: 18px;

`;

export const CheckboxLabel = styled.label`
font-family: Poppins;
font-size: 12px;
font-weight: 400;
line-height: 18px;
color: #333333;
text-align: left;
`;

export const CheckLabel = styled.label`
font-family: Poppins;
font-size: 14px;
font-weight: 400;
line-height: 18px;
color: #333333;
text-align: left;
`;


export const InputTextarea = styled.textarea`
  border-radius: 12px;
  border: 1px solid #CACACA;
  padding: 15px;
  font-family: "Poppins", sans-serif;
  font-size: 12px;
  color:#353535;
  width: 100%; 
  resize: vertical; 
  ::placeholder{
    color:black;
  }`;



